function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M56.9391 219.164C114.487 180.98 279.004 104.737 476.687 105.237C674.37 105.736 703.107 -45.3142 692.766 -120.902M-8.37109 7.1876C135.685 45.0575 415.879 72.4575 384.207 -120.902M395.357 348C429.388 267.456 557.106 109.355 795.737 121.299C1034.37 133.242 1138.37 -36.1905 1160.54 -122.4M1330.52 -122.4C1332.15 -58.6917 1294.4 1.2037 1233.25 49.4905C1139.48 123.54 943.431 139.157 886.408 230.97C858.668 275.636 882.062 317.119 916.36 348M1171.72 348C1188.03 298.448 1245.33 190.424 1344 154.747",
  stroke: "url(#paint0_linear_9337_163575)",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_9337_163575",
  x1: -8.37109,
  y1: 112.8,
  x2: 1344,
  y2: 112.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})));

function SvgBannerOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1344,
    height: 72,
    viewBox: "0 0 1344 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerOrange);
export default __webpack_public_path__ + "static/media/BannerOrange.a7d9b6339571e5f2b02c8d83812508b0.svg";
export { ForwardRef as ReactComponent };